import React from 'react';
import { Box, Text } from 'wix-style-react';
import { InfoLine } from '../InfoSection';
import s from './InvoiceHighlight.scss';
export var InvoiceHighlight = function (_a) {
    var amountPaid = _a.amountPaid, dueAmount = _a.dueAmount, dueDate = _a.dueDate, t = _a.t;
    return (React.createElement(Box, { marginTop: "20px", align: "center", direction: "vertical" },
        React.createElement(Box, null,
            React.createElement(Text, { className: s.dueAmount }, dueAmount)),
        React.createElement(Box, { marginTop: "12px" },
            React.createElement(InfoLine, null, t('price-quote.view.highlight-section.point-to-due-date', {
                date: dueDate,
            }))),
        !!amountPaid && (React.createElement(InfoLine, { weight: "bold" }, t('price-quote.view.highlight-section.amount-paid', {
            money: amountPaid,
        })))));
};
//# sourceMappingURL=InvoiceHighlight.js.map